import { render, staticRenderFns } from "./EmailConfigForm.vue?vue&type=template&id=ceb8becc&"
import script from "./EmailConfigForm.vue?vue&type=script&lang=js&"
export * from "./EmailConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports